import {DateHelper, Model} from "@bryntum/schedulerpro";
import {getAging} from "../../other/utils/utils";
import {HasProjectMixin} from "./mixins/HasProjectMixin.jsx";
import {GRID_FIELDS_TO_OPEN_EDITOR} from "../../other/constants/OtherKeys.jsx";
import HasAssignedToMixin from "./mixins/HasAssignedToMixin.jsx";
import { ChecklistItems } from "./ChecklistItems";

export class Checklist extends HasProjectMixin(HasAssignedToMixin(Model)) {
  static get $name() {
    return "Checklist";
  }

  declare id: number | string;
  declare isPhantom: boolean;
  declare title: string;
  declare checkedItems: number;
  declare clientId: number | string;
  declare resourceId: number | string;
  declare taskId: number | string;
  declare archived: boolean;
  declare createdAt: Date;
  declare updatedAt: Date;
  declare creator: number;
  declare updater: number;
  declare order: number;
  declare entityType: number;
  declare canEdit: number;
  declare canView: number;
  declare assignedBoardUsers: number[];

  static get fields() {
    return [
      { name: "title", dataSource: "title" },
      { name: "checkedItems", dataSource: "checked_items", type: "number" },
      { name: "clientId", dataSource: "client", type: "number" },
      { name: "resourceId", dataSource: "resource", type: "number" },
      { name: "taskId", dataSource: "task", type: "number" },
      { name: "archived", dataSource: "archived", type: "boolean" },
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "updatedAt", dataSource: "updated_at", type: "date" },
      { name: "creator", dataSource: "creator" },
      { name: "updater", dataSource: "updater"},
      { name: "order", type: "number" },
      { name: "aging", persist: false },
      { name: "entityType", type: "number", persist: false },
      { name: "nudgeDate", dataSource: "nudge_date" },
      { name: "canEdit", dataSource: "can_edit_grant", type: "integer" },
      { name: "canView", dataSource: "can_view_grant", type: "integer" },
      { name: "reRender", persist: false, type: "boolean" },
      // Registering field in model as filter picker need a field type to load filter types
      { name: "uncheckedItemsCount", persist: false, type: "number" }
    ]
  }

  static swivuGetFieldOriginalSourceName(fieldName: string) {
    const fieldsMaps: Record<string, string> = { assignedBoardUserValues: "assigned_boardusers" }
    return fieldsMaps[fieldName] || super.swivuGetFieldOriginalSourceName?.(fieldName);
  }

  get uncheckedItemsCount() {
    return this.checklistItems?.filter((item: ChecklistItems) => !item.archived && !item.isItemCheck).length || 0;
  }

  get updaterName() {
    return this.project.boardUsersStore.getById(this.updater)?.name || "";
  }

  get creatorName() {
    return this.project.boardUsersStore.getById(this.creator)?.name || "";
  }

  get imageItemsCount() {
    return this.checklistItems?.filter((item: ChecklistItems) => item.image).length;
  }

  get commentItemsCount() {
    return this.checklistItems?.filter((item: ChecklistItems) => item.comment).length;
  }

  get aging() {
    return getAging(this.get("createdAt"));
  }

  get asEntityType() {
    if (this.resourceId) return "Resource";
    else if (this.taskId) return "Task";
    else if (this.clientId) return "Client";
    return ""
  }

  get entity() {
    if (!this.project) return null;
    if (this.resourceId) return this.project.resourceStore.getById(this.resourceId);
    if (this.taskId) return this.project.extraTaskStore.getById(this.taskId);
    if (this.clientId) return this.project.clientsStore.getById(this.clientId);
    return null;
  }

  get [GRID_FIELDS_TO_OPEN_EDITOR.ENTITY_NAME]() {
    return this.entity?.name || "";
  }

  get nudgeDate() {
    let lastNudgeDate = this.get("nudgeDate");
    if (!lastNudgeDate) return undefined;
    lastNudgeDate = new Date(lastNudgeDate);
    const ageNumber = getAging(lastNudgeDate);
    return `${DateHelper.formatCount(ageNumber, "day")}`;
  }

  set nudgeDate(value) {
    this.set("nudgeDate", value);
  }
}

// @ts-expect-error - exposeProperties is internal method
Checklist.exposeProperties();